import { createContext } from "react"

export const AnimationContext = createContext({})